import { Link } from "react-router-dom";
import authService from "../../../services/authService";
import { MdLogoDev, MdSettings } from "react-icons/md";
import "./menubar.css";
import { useState } from "react";
import FormModal from "../FormModal";
import { ChangePasword } from "../../../pages/ChangePassword/ChangePassword";
import { OpeningBalancePage } from "../../../pages/TransactionListingPage/TransactionListingPage";

export interface MenuBarProps {}

export const MenuBar = (props: MenuBarProps) => {
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showOpeningBalancePage, setShowOpeningBalancePage] = useState(false);

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container">
          <a className="navbar-brand" href="/app">
            {/* <img src="../coopman-favicon-icon.png" alt="" height={40} /> */}
            <img src="../coopman_logo.png" alt="" height={30} />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="/navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item dropdown">
                <a
                  href="/"
                  className="nav-link dropdown-toggle"
                  onClick={(e) => e.preventDefault()}
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Accounts
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="customers">
                      Customers
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link className="dropdown-item" to="accounts">
                      Account Listing
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="account-types">
                      Account Type Listing
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="account-groups">
                      Account Group(s) Listing (COA)
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link className="dropdown-item" to="balance-enquiry">
                      Balance Enquiry
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="account-statement">
                      Account Statement
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link className="dropdown-item" to="account-officers">
                      Account Officers
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="account-marketers">
                      Account Marketers
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link className="dropdown-item" to="close-account">
                      Close Account <span className="fa fa-close"></span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  href="/"
                  className="nav-link dropdown-toggle"
                  onClick={(e) => e.preventDefault()}
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Transactions
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="transactions">
                      Transactions
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="charges">
                      Charges
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link className="dropdown-item" to="deposits">
                      Deposits
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="withdrawals">
                      Withdrawals
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/transactions"
                      onClick={() => setShowOpeningBalancePage(true)}
                    >
                      Opening Balance Posting
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="cash-till">
                      Till
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="fund-transfers">
                      Fund Transfer
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="fixed-deposits">
                      Fixed Deposit
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  href="/"
                  className="nav-link dropdown-toggle"
                  onClick={(e) => e.preventDefault()}
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Credits
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="loans">
                      Loans
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="over-draft">
                      Overdrafts
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link className="dropdown-item" to="credit-officers">
                      Credit Offiers
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  href="/"
                  className="nav-link dropdown-toggle"
                  onClick={(e) => e.preventDefault()}
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Users
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="users">
                      Users
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="roles">
                      Roles
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link className="dropdown-item" to="tellers">
                      Tellers
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  href="/"
                  className="nav-link dropdown-toggle"
                  onClick={(e) => e.preventDefault()}
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Reports
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="reports">
                      Reports
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="management-report">
                      Management Report
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link className="dropdown-item" to="deposit-summary">
                      Deposit Summary
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="withdrawal-summary">
                      Withdrawal Summary
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link className="dropdown-item" to="credit-officer-report">
                      Credit Officer Report
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link className="dropdown-item" to="loan-report">
                      Loan Report
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link to="settings" className="nav-link">
                  <MdSettings style={{ margin: "0 5px" }} />
                  Settings
                </Link>
              </li>
            </ul>
            <div className="d-flex">
              <ul className="navbar-nav">
                <li>
                  <div className="dropdown">
                    <a
                      href="/"
                      className="d-block text-dark text-decoration-none dropdown-toggle d-flex justify-content-center align-items-center"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <div className="avatar-image">DI</div>
                      <div className="avatar-name">
                        <span>Donnie Imafidon</span>
                        <span>
                          <small>
                            <a href="/">View Profile</a>
                          </small>
                        </span>
                      </div>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <button className="dropdown-item" type="button">
                          Settings
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          type="button"
                          onClick={() => setShowChangePassword(true)}
                        >
                          Change Password
                        </button>
                      </li>
                      <li>
                        <hr />
                      </li>
                      <li>
                        <button className="dropdown-item" type="button">
                          Sign out
                        </button>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>

      {showChangePassword && (
        <FormModal onClose={() => setShowChangePassword(false)}>
          <ChangePasword></ChangePasword>
        </FormModal>
      )}

      {showOpeningBalancePage && (
        <FormModal
          title="Opening Balance"
          onClose={() => setShowOpeningBalancePage(false)}
        >
          <OpeningBalancePage></OpeningBalancePage>
        </FormModal>
      )}
    </>
  );
};
